// extracted by mini-css-extract-plugin
module.exports = {"contactParentWrapper":"contact_contactParentWrapper__J9xYz","contactWrapper":"contact_contactWrapper__3rR25","contactLink":"contact_contactLink__Z6LWr"};